var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-content',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.emailBody)}}),_c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"220"},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('loading')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }